import React, { useContext, useState } from "react";
import DashboardBanner from "src/components/travel/template-parts/DashboardBanner";
import DashboardTiles from "src/components/travel/template-parts/DashboardTiles";
import TravellerProfileForm from "./tile-content/TravellerProfileForm";
import { AuthContext } from "src/context/auth";

const TravelDashboard = () => {
  const [activeView, setActiveView] = useState("tiles");
  const { user } = useContext(AuthContext);

  const handleBackToTiles = () => setActiveView("tiles");

  const renderBottomSection = () => {
    switch (activeView) {
      case "tiles":
        return <DashboardTiles onTileClick={(view) => setActiveView(view)} />;

      case "profile":
        return <TravellerProfileForm onBack={handleBackToTiles} />;

      default:
        return <DashboardTiles onTileClick={(view) => setActiveView(view)} />;
    }
  };

  return (
    <div className="mx-auto max-w-[1300px] px-8 pb-10 pt-12">
      <h1 className="mb-6 text-4xl font-extrabold text-[#2D0B31]">Welcome, {`${user?.first_name || ""} ${user?.last_name || ""}`.trim()}</h1>

      <div className="mb-8 flex gap-6">
        <div className="flex flex-shrink flex-grow">
          <DashboardBanner />
        </div>
      </div>

      <div
        key={activeView}
        className="animate-fade-in relative">
        {renderBottomSection()}
      </div>
    </div>
  );
};

export default TravelDashboard;
